/* eslint-disable react/no-danger */
import type { ReactNode } from 'react';
import React, { useContext } from 'react';
import { ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL } from 'Components/utils/identifiers/constants';
import { ICONS } from 'Components/utils/icon/icons';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { CriteriaContext } from 'Components/widgets/criteria/CriteriaContext';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { Layer } from 'Components/frameworks/layer/Layer';
import { Modal } from 'Components/frameworks/modal/Modal';
export type CriteriaModalProps = {
  children: ReactNode;
  onClose?: () => unknown;
  onReset?: () => unknown;
  onValidate?: () => unknown;
};
export const CriteriaModal = ({ children, onClose, onReset, onValidate }: CriteriaModalProps) => {
  const { isDesktop } = useResponsive();
  const [criteriaContext] = useContext(CriteriaContext);
  const buttons = (
    <div className="relative mt-auto flex w-full items-center justify-between bg-white p-10 px-25 shadow lg:p-0 lg:shadow-none">
      <Button
        onClick={() => {
          onReset?.();
        }}
        theme="link"
      >
        {t('faceting.reset')}
      </Button>
      <Button
        onClick={() => {
          onValidate?.();
        }}
      >
        {t('faceting.validate')}
      </Button>
    </div>
  );
  const ariaLabel = t('faceting.when.duration');
  const closeLabel = t('common.close');

  const onCloseModal = () => {
    onClose?.();
  };

  return isDesktop ? (
    <Modal
      ariaLabel={ariaLabel}
      className="p-20 text-center"
      closeLabel={closeLabel}
      onClose={() => {
        onClose && onClose();
      }}
    >
      {children}
      {buttons}
    </Modal>
  ) : (
    <Layer
      ariaLabel={ariaLabel}
      ariaLabelledby={ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL}
      buttonLeft={{
        iconName: ICONS.ARROW_TAIL_LEFT,
        label: t('common.backNavigation'),
        onClick: onCloseModal,
      }}
      closeLabel={closeLabel}
      hasAnimateEnter
      header={
        <div
          className="text-center text-20 font-normal text-black"
          dangerouslySetInnerHTML={{
            __html: criteriaContext.layerHeader,
          }}
          id={ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL}
        />
      }
      onClose={onCloseModal}
    >
      <div className="scroll-y h-[calc(100%-70px)]">{children}</div>
      {buttons}
    </Layer>
  );
};
